var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgRatingStar = function SvgRatingStar(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 25,
    viewBox: "0 0 17 16",
    fill: "#013A63",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.95918 0.888703L11.3244 3.60285C11.5614 4.07522 12.0192 4.39548 12.5506 4.47554L15.6079 4.90788C16.9404 5.10003 17.4717 6.7013 16.5071 7.62203L14.2918 9.7357C13.9076 10.104 13.7359 10.6244 13.8258 11.1448L14.349 14.1312C14.5779 15.4282 13.18 16.421 11.9947 15.8125L9.25615 14.4034C8.78202 14.1632 8.21797 14.1632 7.74384 14.4034L5.00531 15.8125C3.8118 16.429 2.42211 15.4362 2.651 14.1312L3.17418 11.1448C3.2641 10.6244 3.09243 10.104 2.70821 9.7357L0.492875 7.62203C-0.471741 6.7013 0.0596075 5.10003 1.39209 4.90788L4.44943 4.47554C4.98079 4.40348 5.43857 4.07522 5.67564 3.60285L7.04081 0.888703C7.63757 -0.296234 9.36242 -0.296234 9.95918 0.888703Z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgRatingStar, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/rating-star.300353db.svg";
export { ForwardRef as ReactComponent };